export const buefyConfigs = {
  defaultIconComponent: "fa-icon",
  defaultIconPack: "fas",
  defaultToastDuration: 3000,
  defaultToastPosition: "is-bottom",
};
